"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    bytecloudDomainIDService: ()=>bytecloudDomainIDService
});
const external_base_domain_id_service_js_namespaceObject = require("./base-domain-id.service.js");
const url = (()=>{
    try {
        if ('undefined' != typeof location && 'string' == typeof location.href) return location.href;
        console.info('[@bytecloud/common-lib]: get location.href failed, use empty string');
        return '';
    } catch (error) {
        console.error('[@bytecloud/common-lib]: ', error);
        return '';
    }
})();
const bytecloudDomainIDService = new external_base_domain_id_service_js_namespaceObject.BaseBytecloudDomainIDService({
    url
});
exports.bytecloudDomainIDService = __webpack_exports__.bytecloudDomainIDService;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "bytecloudDomainIDService"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
